/**
 * HeartDivider — the brand's gold "line ♥ line" divider.
 * Decorative only (aria-hidden). Center it by passing `justify-center`
 * via className; color defaults to gold-500, override with e.g.
 * className="text-gold-400" (lines + heart follow currentColor).
 */
export default function HeartDivider({ className = '' }) {
  return (
    <div aria-hidden="true" className={`flex items-center gap-3 text-gold-500 ${className}`}>
      <span className="h-px w-16 bg-current" />
      <svg viewBox="0 0 24 24" className="h-3.5 w-3.5" aria-hidden="true">
        <path
          d="M12 21C7 16.6 3 13.3 3 9.3 3 6.4 5.2 4.5 7.7 4.5c1.7 0 3.2.9 4.3 2.4 1.1-1.5 2.6-2.4 4.3-2.4 2.5 0 4.7 1.9 4.7 4.8 0 4-4 7.3-9 11.7Z"
          fill="currentColor"
        />
      </svg>
      <span className="h-px w-16 bg-current" />
    </div>
  );
}
